export default __webpack_public_path__ + "static/media/car-quality.68f7b3ff.md";